import { Account } from "@common/types/domains/accounting/account";

// Kick-seeded rules store an account as "{code} - {name}", custom ones as the
// bare name.
export function findAccountByStoredName<TAccount extends Account>(
    storedName: string,
    accounts: TAccount[],
): TAccount | undefined {
    const byName = accounts.find((account) => account.name === storedName);
    if (byName || !storedName.includes(" - ")) {
        return byName;
    }
    const originalCode = Number(storedName.split(" - ")[0]);
    if (Number.isNaN(originalCode)) {
        return undefined;
    }
    return accounts.find(
        (account) => account.kickOriginalCode === originalCode,
    );
}
